// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            color: "common.ui3",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                padding: 0;
                &&& > span[class*="IconWrapper-"] {
                    top: 2px;
                }
            `,
        },
        cssOverrides: {
            wrapper: css``,
            menu: css``,
            menuItem: css`
                display: inline;
                width: 100%;
                background: ${getColor("common.white")};

                &:hover,
                &:focus,
                &:active {
                    color: ${getColor("text.main")};
                    background: ${getColor("common.ui4")};
                }
                button {
                    margin-left: 0 !important;
                }
            `,
        },
        iconProps: { src: "MoreVertical" },
    },
} as xBaseTheme["overflowMenu"];
